<template>
  <div class="HeatMapBackground" id="container" @click="heatCoodChange"></div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'HeatMapBackground',
  props: {
    /* 等比缩放需要使用ProjectInfo
     ProjectInfo.ScreenRatio: {
        w_Ratio: 100,  单位%   宽度缩放比
        h_Ratio: 100,  单位%   高度缩放比
      }, 
    */
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      mywinmap: null, // 点位
      mywpoint: null, // 点位
      mapType: '2', // 地图类型
      mapBasicSetting: null, // 地图基本设置
      vatchvalue: '',
      mykey: '',
    };
  },
  computed: {
    ...mapState({
      // 热力图 列表数据
      // heatMapList: state => state.heatMapList,
      // 经纬度
      heatMapLngLat: state => state.heatMapLngLat,
      // 热力图 当前点位 index 值
      currentheatmap: state => state.currentheatmap,
    }),
  },
  mounted() {
    this.mykey = this.Configuration.propertyData.MapKey.value;
    this.$nextTick(() => {
      this.initMap();
    });
    this.mapType = this.Configuration.propertyData.mapType.value;
    this.mapBasicSetting = this.Configuration.propertyData.mapBasicSetting.value;
  },
  watch: {
    heatMapLngLat: {
      handler: function (nV) {
        // this.mywinmap.clearMarker();
        setTimeout(() => {
          this.pointHeatMap(nV);
        }, 3000);
      },
      deep: true,
    },
    currentheatmap: {
      handler: function (nV) {
        this.heatCoodChange2(nV);
      },
    },
    Configuration: {
      deep: true,
      handler: function (newValue) {
        // this.initMap();
      },
    },
  },
  methods: {
    // 地图点击
    handleClick(e) {
      console.log('!!!!!!!!!!', e);
      e.stopPropagation();

      this.$store.commit('set_CurrentConfigration', this.Configuration);
      this.$store.commit('set_ContextMenu', {
        isOpen: false,
      });
    },
    // 点击 中心点
    heatCoodChange(road) {
      console.log('移动1', road);
      // this.mywinmap.moveMapContor('114.99982', '25.85817');
      // this.mywinmap.moveMapContor(road.lng, road.lat);
    },
    heatCoodChange2(road) {
      console.log('移动2', road);
      this.mywinmap.moveMapContor('114.99982', '25.85533');
      // this.mywinmap.moveMapContor(road.lng, road.lat);
    },
    pointHeatMap(list) {
      this.mywinmap.moveMapContor('114.99982', ' 25.85533');
      let heatdata = [];
      list.forEach(element => {
        heatdata.push([element.lng, element.lat, element.count]);
      });
      this.mywinmap.openHeatmap(heatdata, 500, 30);
    },
    // 初始化地图
    initMap() {
      this.mywinmap = null;
      let map = document.getElementById('HeatMapBackground');
      console.log('map', map);
      this.mywinmap = new winMap('container', {
        maptype: this.mapType.type, // 地图类型
        key: this.mykey,
        // key: 'WKvseQPCaNwRbBDnLJtnm',
        // maplon: this.mapBasicSetting.coordinate.lng,
        maplon: '114.99982',
        // maplat: this.mapBasicSetting.coordinate.lat,
        maplat: '25.85533',
        level: this.mapBasicSetting.zoom + '',
        http_server: 'https://gisapi.xyabcd.com',
        jwt: localStorage.getItem('_t'),
      });
    },
  },
  // Configuration: {
  //   componentTitle: '热力地图背景',
  //   componentName: 'HeatMapBackground',
  //   componentOverViewImg: './img/backgrounds/MapBackground.png',
  //   id: 'HeatMapBackground',
  //   style: {
  //     backgroundColor: '#19242D',
  //   },
  //   propertyData: {
  //     mapBasicSetting: {
  //       value: {
  //         coordinate: {
  //           lng: '114.99982',
  //           lat: '25.85533',
  //         },
  //         zoom: 1,
  //         is3dMap: false,
  //       },
  //       propertyComponentName: 'mapBasicSetting',
  //       lable: '地图基本设置',
  //     },
  //     mapType: {
  //       value: {
  //         type: '2',
  //       },
  //       propertyComponentName: 'mapType',
  //       lable: '地图类型',
  //     },
  //     MapKey: {
  //       propertyComponentName: 'MapKeyConfiger',
  //       value: 'WKvseQPCaNwRbBDnLJtnm',
  //     },
  //   },
  // },
};
</script>

<style lang="scss" scoped>
.HeatMapBackground {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;

  .road-condition {
    position: absolute;
    bottom: 20%;
    left: 10%;
    width: 20vw;
    min-width: 200px;
    min-height: 100px;
    height: 16vh;
    background: #2f5c6b9a;
    border-radius: 10px;

    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    background: url('../../../assets/img/mapbk.png') no-repeat;
    background-size: 100% 100%;

    .row {
      width: 65%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .color-block {
        width: 10%;
        min-width: 30px;
        height: 6px;
        border-radius: 4px;
      }

      .title {
        width: 70%;
        color: #fff;
        text-align: left;
      }
    }
  }
}

.mapbackground {
  overflow: hidden;
  width: 100%;
  height: 100%;
  margin: 0;
  font-family: '微软雅黑';
}

:deep().jqsbInfoBgleft {
  img {
    // width: 111px !important;
    // height: 114px !important;
    max-width: none;
  }
}

:deep().wzks_scenicImg2 {
  width: 100% !important;
}
</style>
